
<template>
  <div>
    <div class="mybox">
        <div class="title">安全运行</div>
        <div class="box">
            <SecurityStatus></SecurityStatus>
        </div>
      </div>
      <div class="mybox">
        <div class="title">风险指数</div>
        <div class="box">
          <RiskIndex></RiskIndex>
        </div>
      </div>
      <div class="mybox">
        <div class="title">物流减排</div>
          <div class="box wljp">
            <div class="left">
              <div id="is_pie3" class="echarts"></div>
              <div class="text">
                <li>全年运输能源消耗：<b>{{fullYearPower}}</b>TCE</li>
                <li>全年减少碳排放：<b>{{fullYearLess}}</b>吨</li>
              </div>
            </div>
            <div class="right">
              <div class="top">
                <div class="title">安全趋势</div>
                <div id="is_line1" class="echarts"></div>
              </div>
              <div class="bottom">
                <div class="title">节能减排</div>
                <div id="is_bar2" class="echarts"></div>
              </div>
            </div>
          </div>
      </div>
      <div class="mybox">
        <div class="title">渠道分布</div>
        <div class="box clstate">
          <div class="left">
            <div id="regionChartsMap" style="width: 100%; height: 100%"></div>
          </div>
          <div class="right">
            <li v-for="(item, index) in qdlist" :key="index">
              {{ item.name }}:{{ item.value }}
            </li>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
import api from "@/apis/appright";
import SecurityStatus from '@/views/SecurityManagement/SecurityStatus.vue' //安全状态
import RiskIndex from '@/views/SecurityManagement/RiskIndex.vue' //安全状态
export default {
  components: {
    SecurityStatus,
    RiskIndex
  },
  data() {
    return {
      qdlist: [], //渠道数据
      fullYearPower: '', //全年运输能源消耗
      fullYearLess: '', //全年减少碳排放
    }
  },
  methods: {
    //获取物流减排
    getLessPower() {
      //安全趋势
      api.getReduct().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list[0]
          let _arr = [
            _data.oneSafe,
            _data.twoSafe,
            _data.threeSafe,
            _data.fourSafe,
            _data.fiveSafe,
            _data.sixSafe,
            _data.sevenSafe,
            _data.eightSafe,
            _data.nineSafe,
            _data.tenSafe,
            _data.elevenSafe,
            _data.twelveSafe,
          ]
          this.fullYearPower = _data.energyConsume
          this.fullYearLess = _data.reduCarbon
          this.is_line1(_arr)
          this.is_pie3(_data.newEnergy, _data.diesel, _data.gasoline)
        }
      })
      //节能减排
      api.getReductDown().then((data) => {
        if (data.code == 10000) {
          let _data = data.data
          let _year = []
          let _oil = []
          let _newPower = []
          for (var i in _data) {
            _year.push(_data[i].safeYear)
            _oil.push(_data[i].fuelTraffic)
            _newPower.push(_data[i].newEnergy)
          }
          this.is_bar2(_year, _oil, _newPower)
        }
      })
    },
    //获取渠道分布
    getWay() {
      api.getChannel().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list[0];
          this.qdlist = [
            { id: 0, name: "华中区", value: _data.centralNum },
            { id: 1, name: "华东区", value: _data.eastNum },
            { id: 2, name: "华北区", value: _data.northNum },
            { id: 3, name: "华南区", value: _data.southNum },
            { id: 4, name: "华西区", value: _data.westNum },
          ];
        }
      });
    },
    //获取地图
    drawregionChartsMap() {
      let dataList = [{ name: "四川", value: 1400 }]; // 该数据是从服务器获取到的数据
      let option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            if (isNaN(params.value)) {
              params.value = 0;
            }
            return params.name + " <br> " + params.value; //自行定义formatter格式
          },
        },
        visualMap: {
          min: 0,
          max: 1500,
          textStyle: {
            color: "#fff", fontSize:this.$echartsFontSize-4,
          },
          left: "30",
          bottom: "30",
          text: ["高", "低"], //取值范围的文字
          inRange: {
            color: ["rgba(0,204,255, 0.4)", "rgba(0,204,255, 1)"], //取值范围的颜色
          },
          show: false, //图注
        },
        geo: {
          map: "china",
          roam: false, //不开启缩放和平移
          zoom: 1, //视角缩放比例
          label: {
            normal: {
              show: false,
              fontSize: this.$echartsFontSize-6,
              color: "#ccd0f2", textShadowBlur:3, textShadowColor:'#000',
            },
            emphasis: {
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              // areaColor:'rgba(8,41,196, 0.2)',//默认区域颜色
              areaColor:'rgba(0,204,255, 0.2)',//默认区域颜色
              borderColor: "#00ccff",
            },
            emphasis: {
              areaColor: "#00ccff", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            name: "信息量",
            type: "map",
            geoIndex: 0,
            data: dataList,
          },
        ],
      };
      let mychart = this.$echarts.init(
        document.getElementById("regionChartsMap")
      );
      mychart.setOption(option);
      this.$nextTick(() => {
        mychart.resize(); // 这里是为了解决，tab刷新的时候，图表不刷新的问题。
      });
    },

    is_line1(a) {
      let is_line1 = echarts.init(document.getElementById('is_line1'))
      is_line1.setOption({
        color: ['#fff45c', '#24ffb1', '#00ccff', '#ff5f8c'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'cross',
          },
        },
        xAxis: {
          type: 'category',
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#3570ff' } },
        },
        yAxis: {
          axisLabel: { show: false },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#3570ff' } },
          splitNumber: 3,
          splitLine: { show: false },
        },
        legend: { show: false },
        grid: { left: '5%', right: '20px', top: '50px', bottom: '10px' },
        series: [
          {
            name: '安全趋势',
            type: 'line',
            data: a,
            symbolSize: 0,
            symbol: 'circle',
          },
        ],
      })
    },
    is_pie3(a, b, c) {
      let is_pie3 = echarts.init(document.getElementById('is_pie3'))
      is_pie3.setOption({
        color: ['#3570ff', '#24ffb1', '#fff45c'],
        tooltip: {
          trigger: 'item',
          textStyle: { fontSize: this.$echartsFontSize },
        },
        legend: { show: false },
        series: [
          {
            name: '类型',
            type: 'pie',
            radius: ['18%', '30%'],
            center: ['50%', '32%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#081693',
              borderWidth: 2,
            },
            label: {
              show: true,
              color: '#ccd0f2',
              fontSize: this.$echartsFontSize - 2,
              formatter: '{b}\n{num|{d}%}',
              lineHeight: this.$echartsFontSize + 4,
              rich: {
                num: {
                  color: '#fff',
                  fontSize: this.$echartsFontSize,
                },
              },
            },
            data: [
              { value: a, name: '新能源用量' },
              { value: b, name: '柴油用量' },
              { value: c, name: '汽油用量' },
            ],
          },
        ],
      })
    },
    is_bar2(a, b, c) {
      let is_bar2 = echarts.init(document.getElementById('is_bar2'))
      is_bar2.setOption({
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['#24ffb1', '#fff45c'],
        legend: {
          right: 40,
          top: 16,
          itemGap: 30,
          textStyle: {
            color: '#fff',
            fontSize: this.$echartsFontSize - 2,
          },
          itemWidth: 15,
          itemHeight: 15,
        },
        xAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLabel: { color: '#fff', fontSize: this.$echartsFontSize },
          axisLine: { lineStyle: { color: '#3570ff' } },
          data: a,
        },
        yAxis: {
          axisTick: { show: false },
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#3570ff' } },
          splitLine: { show: false },
        },
        grid: { left: '5%', right: '20px', top: '50px', bottom: '50px' },
        series: [
          {
            name: '燃油',
            type: 'bar',
            barWidth: '15%',
            data: b,
          },
          {
            name: '新能源',
            type: 'bar',
            barWidth: '15%',
            data: c,
          },
        ],
      })
    },
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getWay(); //获取渠道分布
    this.drawregionChartsMap(); //获取地图
    this.getLessPower(); //获取物流减排
  },
  // 方法集合
}
</script>
<style lang='less' scoped>
  .clstate {
    display: flex;
    flex-direction: row;
    .left {
      width: 60%;
    }
    .right {
      flex: 1;
      padding-left: 2rem;
      color: #24ffb1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      li {
        margin: 13px 0;
      }
    }
  }
  .wljp {
    display: flex;
    flex-direction: row;
    .left {
      position: relative;
      width: 45%;
      .text {
        position: absolute;
        bottom: 1rem;
        width: 100%;
        li {
          margin: 0.3rem 0;
          font-size: 0.6rem;
          text-align: center;
          b {
            font-size: 1.2rem;
            margin-right: 5px;
            color: #24ffb1;
            font-family: 'DS-DIGI';
          }
        }
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      .top {
        height: 45%;
        position: relative;
      }
      .bottom {
        flex: 1;
        position: relative;
      }
      .title {
        position: absolute;
        top: 0.5rem;
        left: 10px;
        color: #00ccff;
      }
    }
  }
  .echarts {
    width: 100%;
  }
</style>